<template>
    <div class="container">
        <div class="banner"  :style="{backgroundImage: 'url(' + banner1 + ')'}" v-if="type === 1"></div>
        <div class="banner"  :style="{backgroundImage: 'url(' + banner2 + ')'}" v-if="type === 2"></div>
        <div class="banner"  :style="{backgroundImage: 'url(' + banner3 + ')'}" v-if="type === 3"></div>
        <div class="width o_h">
            <div class="main o_h box_sizing bg_white" v-if="type === 1">
                <h1 class="font_30 bold">APP下载</h1>
                <ul class="clearfix">
                    <li class="f_l">
                        <img class="m_b1" :src="Android_school" alt="">
                        <a class="font_16 pointer" href="https://bjyijie.com.cn/yijie/upload/app-apk/学校.apk">安卓下载</a>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="ios_school" alt="">
                        <span class="font_16">苹果下载</span>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="wx_code" alt="">
                        <span class="font_16">微信小程序</span>
                    </li>
                </ul>

            </div>
            <div class="main o_h box_sizing bg_white" v-if="type === 2">
                <h1 class="font_30 bold">APP下载</h1>
                <ul class="clearfix">
                    <li class="f_l">
                        <img class="m_b1" :src="Android_garden" alt="">
                        <a class="font_16 pointer" href="http://bjyijie.com.cn/yijie/upload/app-apk/园所.apk">安卓下载</a>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="ios_garden" alt="">
                        <span class="font_16">苹果下载</span>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="wx_code" alt="">
                        <span class="font_16">微信小程序</span>
                    </li>
                </ul>

            </div>
            <div class="main o_h box_sizing bg_white" v-if="type === 3">
                <h1 class="font_30 bold">APP下载</h1>
                <ul class="clearfix">
                    <li class="f_l">
                        <img class="m_b1" :src="Android_student" alt="">
                        <a class="font_16 pointer" href="https://bjyijie.com.cn/yijie/upload/app-apk/学生.apk">安卓下载</a>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="ios_student" alt="">
                        <span class="font_16">苹果下载</span>
                    </li>
                    <li class="f_l">
                        <img class="m_b1" :src="wx_code" alt="">
                        <span class="font_16">微信小程序</span>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    import { ImgUrl } from '../api/common_api';

    export default {
        name: "AppDownload",
        data() {
            return {
                type: -1,
                Android_garden: ImgUrl + 'Android_garden.png',
                Android_school: ImgUrl + 'Android_school.png',
                Android_student: ImgUrl + 'Android_student.png',
                ios_garden: ImgUrl + 'ios_garden.png',
                ios_school: ImgUrl + 'ios_school.png',
                ios_student: ImgUrl + 'ios_student.png',
                wx_code: ImgUrl + 'wx_code.jpg',
                banner1: require('../assets/image/down_sch_banner.png'),
                banner2: require('../assets/image/down_gar_banner.png'),
                banner3: require('../assets/image/down_stu_banner.png'),
            }
        },
        mounted() {
            this.type = Number(this.$route.query.type)
        },
        methods: {}
    }
</script>

<style scoped lang="stylus">
    .banner {
        width: 100%;
        height: 260px;
        background-position center center
        background-repeat no-repeat
        background-size cover
    }
    .main {
        padding 80px 40px
        margin 2px 0

        h1 {
            text-align center
            margin-bottom 80px
        }

        li {
            width 260px
            height 260px
            padding 34px 30px 20px
            box-sizing border-box
            box-shadow: 4px 6px 24px 0 rgba(8,8,11,0.2);
            text-align center
            margin-right: 170px;

            img {
                width 160px
                height 160px
                display block
                margin 0 auto
                margin-bottom 20px
            }

            &:last-child {
                margin-right 0
            }

            a:hover {
                color #f16765
            }
        }
    }

</style>
